module.exports = __webpack_public_path__ + "static/media/location_icon.b38f1fc5.svg";